import { Typography } from "@/components/essentials/typography";
import { HStack, Spacer, type BoxProps, forwardRef, Icon } from "@chakra-ui/react";
import { Box } from "@/components/essentials/box";
import { type FC } from "react";
import { FaChevronRight } from "react-icons/fa";

export interface User {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly address?: string;
}

type UserInfoType = "simple" | "edit" | "new";

export interface UserInfoProps extends BoxProps {
  readonly type?: UserInfoType;
  readonly isSelect?: boolean;
  readonly user?: User;
}

const NameWithAddress: FC<User> = (props) => {
  const { lastName, firstName, address } = props;
  return (
    <Box w="100%">
      <Typography variant="display6" mb="0.3125rem">
        {lastName} {firstName}
      </Typography>
      <Typography variant="text4">{address}</Typography>
    </Box>
  );
};

export const UserInfo = forwardRef<UserInfoProps, "div">((props, ref) => {
  const { type = "edit", user, isSelect, ...rest } = props;

  return (
    <HStack
      ref={ref}
      justifyContent="space-between"
      borderWidth="1px"
      borderColor={isSelect ? "secondary.main" : "gray.light"}
      px="1rem"
      py={type === "new" ? "1.5rem" : "1rem"}
      boxSizing="border-box"
      borderRadius="0.5rem"
      backgroundColor={isSelect ? "theme.yellow.10" : "mono.light.100"}
      {...rest}
    >
      {type === "new" ? (
        <Typography variant="display6">新しい住所を追加する</Typography>
      ) : (
        <NameWithAddress {...user} />
      )}
      <Spacer />
      {type !== "simple" && <Icon as={FaChevronRight} color="mono.dark.54" />}
    </HStack>
  );
});
